import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Dropdown } from 'shared/ui'
import { savedRepliesSortItems } from 'entities/CannedMessages'
import { useSavedRepliesContext } from 'pages/settings/pages/savedReplies/context/savedRepliesContext'
import styles from './styles.module.scss'

export const SavedRepliesOrder = observer(() => {
  const store = useSavedRepliesContext()
  const { handleSelectSort } = store
  const [open, setOpen] = useState(false)

  return (
    <div className={styles.wrapOrder}>
      <Dropdown
        ariaLabel={'SavedRepliesOrder'}
        icon={'filter'}
        tooltipProps={{
          label: 'Sort by',
          placement: 'top',
        }}
        items={savedRepliesSortItems.map((item) => ({
          ...item,
          activeValue: store.order === item.id,
        }))}
        typeButton={'button'}
        variantTriggerButton={'outlined'}
        onChange={handleSelectSort}
        placement={'bottom-start'}
        buttonProps={{
          text: savedRepliesSortItems.find((item) => item.id === store.order)?.label,
          isRight: true,
          icon: open ? 'chevronUp' : 'chevronDown',
          typeBtn: 'text',
          size: 'medium',
          paddingInline: '12px 8px',
        }}
        onToggle={setOpen}
        sizeTriggerButton={'medium'}
      />
    </div>
  )
})
